var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.528 1a6.468 6.468 0 0 0-6.473 6.452v7.153a30.38 30.38 0 0 1-2.055.073c-.707 0-1.385.029-2.055.069V7.452A6.474 6.474 0 0 0 1 7.452v17.096a6.473 6.473 0 0 0 12.945 0v-7.153A30.38 30.38 0 0 1 16 17.322c.707 0 1.385-.029 2.055-.069v7.295a6.474 6.474 0 0 0 12.945 0V7.452A6.468 6.468 0 0 0 24.528 1zM7.472 3.643a3.818 3.818 0 0 1 3.82 3.809v7.575a21.77 21.77 0 0 0-5.5 1.555 9.998 9.998 0 0 0-2.134 1.273V7.452a3.818 3.818 0 0 1 3.814-3.809zm3.82 20.905a3.82 3.82 0 0 1-7.64 0v-1.715c0-1.515 1.2-2.95 3.211-3.843a18.833 18.833 0 0 1 4.429-1.295v6.853zm13.236 3.809a3.82 3.82 0 0 1-3.82-3.809v-7.575a21.77 21.77 0 0 0 5.5-1.555 9.998 9.998 0 0 0 2.134-1.273v10.403a3.818 3.818 0 0 1-3.814 3.809zM25.137 13a18.834 18.834 0 0 1-4.429 1.295V7.452a3.82 3.82 0 0 1 7.64 0v1.715c0 1.508-1.2 2.943-3.211 3.833z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/ONE.b10e35440e2722b74caf688c38e7a551.svg";
export { ForwardRef as ReactComponent };